import { render, staticRenderFns } from "./OfficeList.vue?vue&type=template&id=927776c6&"
import script from "./OfficeList.vue?vue&type=script&lang=js&"
export * from "./OfficeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports